import { useSelector } from "react-redux";
import { CONST_VALUE } from "../utils/Global";

export function useTotalFactura() {

    const procedimientos = useSelector((state) => state.facturaredux.procedimientos);
   
    const subtotal = procedimientos.reduce((acc, procedimiento) => acc + (procedimiento.cantidad * procedimiento.precio), 0);
    const iva = subtotal * ( CONST_VALUE.IVA / 100 );
    const total = subtotal + iva;

    return { subtotal, iva, total };
}